import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import HvacTips from "./pages/HvacTips";
import Reviews from "./pages/Reviews";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tips" element={<HvacTips />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
